import { Accommodation, Addon, Property } from '@data/models';
import { apiCall } from '../axios';
import CartTotals from '@data/models/CartTotals';
import ReservationItem from '@data/models/ReservationItem';

export class CartService {
  static async calculate(
    property: Property,
    items: ReservationItem[],
    currency: string,
    checkIn: Date,
    checkOut: Date
  ): Promise<CartTotals> {
    // TODO: after implementing the addons on backend, we should include them here
    const rates: Dict[] = [];
    for (let i = 0; i < items.length; i++) {
      const item = items[i].model;
      if (item?.type === 'accommodation') {
        const accommodation: Accommodation = item.item as Accommodation;
        for (let j = 0; j < item.amount; j++) {
          rates.push({
            adults: accommodation.adults,
            kids: accommodation.kids,
            rateId: accommodation.rateId,
          });
        }
      } else {
        const addon: Addon = item?.item as Addon;
      }
    }

    const body: Dict = {};
    body.lang = 'en';
    body['data[checkIn]'] = checkIn.toISOString().slice(0, 10);
    body['data[checkOut]'] = checkOut.toISOString().slice(0, 10);
    body['data[currency]'] = currency?.toUpperCase() || 'USD';
    body['data[rates]'] = JSON.stringify(rates);
    body['property_id'] = property.id;

    return await apiCall(CartTotals)('post', '/calculateTotals', body, {});
  }
}
